





















import VueOptions from '@utils/VueOptions'
import EventInfoForCard from '@ui/cards/EventInfoForCard'

settings =
  name: "CampaignDraftCard"
  vue:
    props: ['campaign', 'actions']

    computed:
      data: -> @campaign.data

      logoLetters: ->
        words = "#{@data.name}".split(' ').slice(0, 2)
        letters = words[0].charAt(0)
        letters += words[1].charAt(0) if words[1]
        letters

    methods:
      hiRemove: -> @actions.remove()

export default VueOptions.vue settings
